// Vendor Libs
import {LOCATION_CHANGE, push} from 'redux-first-history';
import {find, map, zipObject} from 'lodash';

// Configs
import servicesConfig from '../../config/services-config';

const routerMiddleware = (store) => (next) => (action) => {
    const {dispatch} = store;
    const {type} = action || {};

    next(action);

    const actions = {
        [LOCATION_CHANGE]: () => handleLocationChange(dispatch, action),
    };

    if (actions[type]) {
        actions[type]();
    }
};

function handleLocationChange(dispatch, action) {
    const {payload: {location: {pathname} = {}} = {}} = action;

    if (pathname === '/') {
        updateRouterParams(dispatch, action);
        dispatch(push('/media-items'));
    } else {
        updateRouterParams(dispatch, action);
    }
}

function updateRouterParams(dispatch, {payload: {location, location: {pathname} = {}} = {}}) {
    const config = find(servicesConfig, [
        'route',
        map(servicesConfig, 'route')
            .filter((route) => route)
            .sort((a, b) => b.length - a.length)
            .find((route) => pathname.slice(1).startsWith(route)),
    ]);

    dispatch({
        location,
        routerParams: config
            ? zipObject(config.activeRowKeys, pathname.replace(`/${config.route}`, '').replace('/', '').split('/'))
            : {},
        type: 'ROUTER_UPDATE',
    });
}

export default routerMiddleware;
